import axios from 'axios'
import { createContext, useContext, useEffect, useState } from 'react'
import { constants } from '../Constants'

// Crear el contexto
export const EventContext = createContext()

// Hook personalizado para acceder al contexto de eventos
export const useEventContext = () => useContext(EventContext)

export const EventProvider = ({ children }) => {
  const [events, setEvents] = useState([])
  const user = JSON.parse(localStorage.getItem('user'))

  const getEvents = async () => {
    try {
      const response = await axios.get(
        `${constants.urlLocal}events/getAll/${user.id}`
      )
      const json = response.data
      if (json.ok) {
        const formattedEvents = json.events.map(event => ({
          ...event,
          start: new Date(event.start),
          end: new Date(event.end),
        }))
        setEvents(formattedEvents)
      }
    } catch (error) {
      console.error('Error al obtener eventos:', error)
    }
  }

  useEffect(() => {
    getEvents()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []) // Dependencia vacía para ejecutar solo una vez al montar

  const updateEvents = newEvents => {
    setEvents(newEvents)
    getEvents() // Obtener los eventos actualizados del servidor
  }

  return (
    <EventContext.Provider value={{ events, updateEvents }}>
      {children}
    </EventContext.Provider>
  )
}
